import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import PageTitle from '../controls/PageTitle'
import * as TimeseriesActionCreators from '../../actions/timeseries'
import TimeseriesListView from './TimeseriesListView'

class TimeseriesListPage extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesByUnit: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      timeseriesByUnit: state.timeseriesByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { timeseriesActions } = this.props
    timeseriesActions.listUnitTimeseries(this.unitId())
  }

  unitId() {
    return parseInt(this.props.match.params.unitId, 10)
  }

  unitTimeseries() {
    const {
      timeseries, timeseriesByUnit,
    } = this.props
    const tsIds = timeseriesByUnit[this.unitId()] || []
    const unitTimeseries = tsIds.reduce((obj, key) => ({
      ...obj,
      [key]: timeseries[key],
    }), { })

    return unitTimeseries
  }

  render() {
    const { timeseriesActions } = this.props
    return (
      <>
        <PageTitle title="Timeseries List" />
        <TimeseriesListView timeseries={this.unitTimeseries()} onSave={timeseriesActions.saveTimeseries} />
      </>
    )
  }
}

export default connect(TimeseriesListPage.mapStateToProps, TimeseriesListPage.mapDispatchToProps)(TimeseriesListPage)
